import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode, useMemo } from 'react';

interface AnimatedMessageProps {
  message: string | ReactNode;
  className?: string;
}

const AnimatedMessage = ({ message, className }: AnimatedMessageProps) => {
  const messageKey = useMemo(
    () => Date.now(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [message],
  );

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={messageKey}
        className={`xs:text-lg sm:text-xl md:text-2xl font-bold text-center max-w-2xl mx-auto px-4 ${className || ''}`}
        initial={{
          opacity: 0,
          y: 20,
          scale: 0.95,
        }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        exit={{
          opacity: 0,
          y: -20,
          scale: 0.95,
        }}
        transition={{
          duration: 0.4,
          ease: [0.4, 0.0, 0.2, 1],
        }}
      >
        {message}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedMessage;
